import { render, staticRenderFns } from "./PostingDetailMultiField.vue?vue&type=template&id=25e7c516&scoped=true&"
import script from "./PostingDetailMultiField.vue?vue&type=script&lang=js&"
export * from "./PostingDetailMultiField.vue?vue&type=script&lang=js&"
import style0 from "./PostingDetailMultiField.vue?vue&type=style&index=0&id=25e7c516&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e7c516",
  null
  
)

export default component.exports